import main from './main'
import admin from './admin'
// import secured from './secured'

import Container from '../controllers/admin/container'
import AdminCode from '../controllers/admin/code'

export default [
    ...main,
    {
        path: '/admin',
        component: Container,
        children: admin,
        meta: {
            secured: true
        },
    },
    {
        path: '/admin/code',
        name: 'admin.code',
        component: AdminCode
    },
    // {
    //     path: '/app',
    //     component: Container,
    //     meta: {
    //         secured: true
    //     },
    //     children: secured
    // }
]